module.exports = __webpack_public_path__ + "static/media/sfuidisplay-thin-webfont.c02be4a0.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/sfuidisplay-thin-webfont.woff2
// module id = 263
// module chunks = 0